const localStorageKeys = Object.freeze({
	AUTO_SUBSCRIBE_WITH_PLAN: 'autoSubscribeWithPlan',
	USER_REACTIONS: 'userReactions',
	REACTION_TABLE_LIMIT: 'reactionTableLimit',
	MUX_POLLING_STATE: 'mux_polling_state',
	REDIRECT_AFTER_LOGIN: 'redirectAfterLogin',
	META_FBP: 'meta_fbp',
	META_FBC: 'meta_fbc',
	META_USER_AGENT: 'meta_user_agent'
});

export default localStorageKeys;